function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_856",
  "data-name": "Ret\\xE2ngulo 856",
  width: 66.402,
  height: 51.496,
  fill: "#fff"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2524",
  "data-name": "Grupo 2524",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_1431",
  "data-name": "Grupo 1431",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_650",
  "data-name": "Caminho 650",
  d: "M57.87,137.05a4.034,4.034,0,0,0,4.03,0l55.855-32.519a4.029,4.029,0,0,0,2.015-3.491v-64.5a4.028,4.028,0,0,0-2.015-3.491L61.9.537a4.047,4.047,0,0,0-4.03,0L2.015,33.052A4.029,4.029,0,0,0,0,36.543v64.5a4.029,4.029,0,0,0,2.015,3.491Z",
  transform: "matrix(0, -1, 1, 0, 0, 119.77)",
  fill: "#0078d7"
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2394",
  "data-name": "Grupo 2394",
  transform: "translate(35.234 35.624)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2393",
  "data-name": "Grupo 2393",
  transform: "translate(0 0)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_852",
  "data-name": "Caminho 852",
  d: "M293.212,388.86a3.36,3.36,0,0,1-4.753,0l-18.981-18.984a5.041,5.041,0,0,1,0-7.13l2.377-2.378a5.041,5.041,0,0,1,7.13,0l11.851,11.851L322.857,340.2a5.04,5.04,0,0,1,7.13,0l2.376,2.378a5.04,5.04,0,0,1,0,7.13Zm0,0",
  transform: "translate(-268.001 -338.426)",
  fill: "#fff"
}))));

function SvgConfirmationHexagon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 137.589,
    height: 119.77,
    viewBox: "0 0 137.589 119.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmationHexagon);
export default __webpack_public_path__ + "static/media/confirmation_hexagon.8ac24bbc.svg";
export { ForwardRef as ReactComponent };